import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import PubSub from 'pubsub-js';
import TitlesForm from '../components/form';
import { ADD_TITLE_BY_CONTENTMANAGER_ID } from '../../../queries/titleContent';

interface IAddTitlesProps {
  refetch: () => void;
}

const AddTitles: React.FC<IAddTitlesProps> = ({ refetch }) => {
  return (
    <Mutation
      mutation={ADD_TITLE_BY_CONTENTMANAGER_ID}
      update={async () => {
        PubSub.publish('CLOSE-DRAWER');
        refetch();
      }}
    >
      {(createTitle: any) => <TitlesForm query_f={createTitle} />}
    </Mutation>
  );
};

export default AddTitles;
